/**
*
* RedSpeakers
*
*/

import React, { useState } from 'react';
import PropTypes from 'prop-types';

import selectSpeakerById from 'helpers/selectSpeakerById';

import Wrapper from 'components/Templates/dynamics/Wrapper';

import RedSpeakersSpeaker from './RedSpeakersSpeaker';

import defaultTextValues from './defaultTextValues';
import SpeakersPlaceholder from './styles/SpeakersPlaceholder';

function RedSpeakers(props){
  const [popupOpen, openSpeakerPopup] = useState(false);

  const {
    commonData,
    commonProps,
    speakers,
    setShowPopup,
  } = props;

  const {
    isEditor,
    helpers
  } = commonProps;

  const {
    componentPayload
  } = commonData;

  const {
    companyLogoType,
    sectionId
  } = componentPayload;

  const thisSpeakerList = componentPayload && componentPayload.speakers ? componentPayload.speakers : '';

  const speakersContent = thisSpeakerList && thisSpeakerList.length > 0 ? thisSpeakerList.map((speaker, i) => {

    const thisSpeaker = selectSpeakerById(speakers, speaker);
    if (!thisSpeaker) return '';

    return (
      <RedSpeakersSpeaker
        key={'RedSpeakersSpeaker-'+speaker+sectionId}
        commonData={commonData}
        commonProps={commonProps}
        thisSpeaker={thisSpeaker}
        speakerCompany={thisSpeaker.speakerCompany}
        companyLogoType={companyLogoType}
        isSingle={true}
        hideDescription={true}
        openSpeakerPopup={openSpeakerPopup}
      />
    );
  }) : '';

  return (
    <>
      {
        popupOpen ? (
          <div style={{
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: 9999999,
            display: 'flex'
          }}>
            <div
              onClick={() => openSpeakerPopup('')}
              style={{
                background: 'rgba(0, 0, 0, 0.2)',
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: 'fixed'
            }}></div>
            <iframe src={popupOpen} style={
              {
                border: 0,
                width: '90%',
                height: '80vh',
                maxWidth: '192rem',
                minHeight: '50rem',
                margin: 'auto',
                display: 'flex',
                alignSelf: 'center',
                zIndex: 1
              }
            } />
        </div>
        ) : ''
      }

      <Wrapper
        {...commonProps}
        addDataContent={isEditor ? {
          editorData: {
            editorType: 'wrapper',
            ...commonData
          },
          helpers: helpers,
          setShowPopup: setShowPopup,
          popupValue: 'speakers-view',
          title: 'Manage Speakers'
        } : ''}
        typeOfStyle={'wrapper'}
        editorData={
          {
            editorType: 'wrapper',
            ...commonData
          }
        }
      >
        <Wrapper
          {...commonProps}
          
          typeOfStyle={'wrapperWithMargin'}
          editorData={
            {
              editorType: 'wrapperWithMargin',
              ...commonData
            }
          }
        >
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'sectionTitleWrapper'}
            editorData={
              {
                editorType: 'sectionTitleWrapper',
                ...commonData
              }
            }
          >
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'sectionTitle'}
              defaultValues={defaultTextValues}
              type={'text'}
              editorData={
                {
                  editorType: 'sectionTitle',
                  ...commonData
                }
              }
            />
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'paragraph'}
              type={'text'}
              defaultValues={defaultTextValues}
              editorData={
                {
                  editorType: 'paragraph',
                  ...commonData
                }
              }
            />
          </Wrapper>
          {
            speakersContent ? (
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'allSpeakersWrapper'}
                editorData={
                  {
                    editorType: 'allSpeakersWrapper',
                    ...commonData
                  }
                }
              >
                {speakersContent}
              </Wrapper>
            ) : isEditor ? (<SpeakersPlaceholder>
              <span>
                {' 👈 Manage speakers inside Section menu to see details'}
              </span>
            </SpeakersPlaceholder>) : null
          }  
        </Wrapper>
      </Wrapper>
    </>
  );
}

RedSpeakers.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  speakers: PropTypes.array,
  setShowPopup: PropTypes.func,
  defaultValues: PropTypes.object,
  thisSpeaker: PropTypes.object,
  companies: PropTypes.array,
};

export default RedSpeakers;
